<template>
	<layout-default class="layout-production" v-bind="layoutProps">
		<template #header-tools>
			<div class="layout-production__nav">
				<nav-tabs :items="navItems" />
			</div>
		</template>

		<slot />

		<rotate-device />
	</layout-default>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import NavTabs from '@/components/nav/NavTabs.vue';
import RotateDevice from '@/components/RotateDevice.vue';
import { NavTabsItemModel } from '@/store/models/NavTabsItem';

import LayoutDefault from './LayoutDefault.vue';

export default defineComponent({
	name: 'LayoutProduction',

	components: {
		LayoutDefault,
		NavTabs,
		RotateDevice,
	},

	computed: {
		layoutProps() {
			return {
				headerOptions: {
					showUserName: true,
					variant: 'wide', // Use wide variant for Production Manager navigation
				},
			};
		},
		navItems(): NavTabsItemModel[] {
			return [
				{
					label: 'Dashboard',
					to: { name: 'Production' },
					matched_routes: ['Production'],
				},
				{
					label: 'Queue',
					to: { name: 'ProductionQueue' },
					matched_routes: ['ProductionQueue', 'ProductionQueueDetails'],
				},
				{
					label: 'Products',
					to: { name: 'Products' },
					matched_routes: [
						'Products',
						'ProductDetails',
						'ProductVariationsManager',
						'ProductNorms',
					],
				},
				{
					label: 'Components',
					to: { name: 'Components' },
					matched_routes: ['Components'],
				},
				{
					label: 'Suppliers',
					to: { name: 'Suppliers' },
					matched_routes: ['Suppliers'],
				},
				{
					label: 'Timeline',
					to: { name: 'ProductionTimeline' },
					matched_routes: ['ProductionTimeline'],
				},
				{
					label: 'Reports',
					to: { name: 'ProductionReports' },
					matched_routes: [
						'ProductionReports',
						'ProductionReportEfficiency',
						'ProductionReportTimeAnalysis',
						'ProductionReportCostAnalysis',
						'ProductionReportStatusOverview',
					],
				},
			];
		},
	},
});
</script>

<style lang="scss">
/**
 * Production Manager Layout Styles
 * 
 * NOTE: These styles are scoped to Production Manager role only.
 * They do not affect Admin or User (Prosthetist) interfaces.
 * 
 * For production-specific variables, see:
 * - ui/src/styles/production/_production-variables.scss
 * - ui/src/styles/production/_production-manager.scss
 */

.layout-production {
	&__nav {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		padding: 0 1rem;

		.nav-tabs {
			width: 100%;
			max-width: 750px;

			@include max-lg-and-portrait {
				max-width: 600px;
			}
		}
	}
}
</style>
